import { useContext, useEffect, useState } from "react";
import moment from "moment";
import MaskService from "../../../../utils/mask/maskService";

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import { ClienteContext } from "../contexts/ClienteContext";
import { notify } from "../../../../utils/notify";

export default function ModalClienteAutorizado({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
}) {
  const {
    generalCustomerId,
    customerPriceTable,
    setCustomerPriceTable,
    expanded,
    loadingInputs,
    listPriceTable,
  } = useContext(ClienteContext);
  const [priceTable, setPriceTable] = useState(null);
  const [discount, setDiscount] = useState("0,00");
  const [expirationDate, setExpirationDate] = useState(null);
  const [errorsModal, setErrorsModal] = useState([]);
  const [defaultDiscount, setDefaultDiscount] = useState("0,00");

  useEffect(() => {
    if (!rowEdit || !rowEdit.data) return;

    const { data } = rowEdit;
    setPriceTable(
      listPriceTable.find((item) => item.id === data.idtabelapreco)
    );
    setDiscount(MaskService.toMask("decimal", data.descontopadrao, 2) || "");
    setExpirationDate(data.dataexpirar || "");
    setDefaultDiscount(
      MaskService.toMask("decimal", data.descontooriginal, 2) || ""
    );
  }, [listPriceTable, rowEdit]);

  useEffect(() => {
    setDefaultDiscount(
      MaskService.toMask("decimal", priceTable?.descontopadrao || 0, 2)
    );
  }, [setPriceTable, priceTable]);

  const handleCloseModal = () => {
    setOpen(false);
    setRowEdit(null);
  };

  const handleAdd = () => {
    const errorsValidation = { error: false, inputs: {} };

    if (!priceTable) {
      errorsValidation.error = true;
      errorsValidation.inputs.priceTable = "Campo obrigatório";
    }

    if (discount === "") {
      errorsValidation.error = true;
      errorsValidation.inputs.discount = "Campo obrigatório";
    }

    if (!expirationDate) {
      errorsValidation.error = true;
      errorsValidation.inputs.expirationDate = "Campo obrigatório";
    }

    if (!(rowEdit && rowEdit.data.idtabelapreco === priceTable.id)) {
      if (
        customerPriceTable.find((item) => item.idtabelapreco === priceTable.id)
      ) {
        errorsValidation.error = true;
        errorsValidation.inputs.priceTable =
          "Já existe um registro com está tabela de preço";
      }
    }

    setErrorsModal(errorsValidation.inputs);
    if (errorsValidation.error) return;

    const body = {
      idtabelapreco: priceTable.id,
      descricao: priceTable.descricao,
      descontopadrao: discount.replaceAll(".", "").replace(",", "."),
      dataexpirar: moment(expirationDate).format("YYYY-MM-DD"),
      descontooriginal: defaultDiscount.replaceAll(".", "").replace(",", "."),
    };

    if (generalCustomerId) body.idcliente = generalCustomerId;

    if (rowEdit && (rowEdit.index || rowEdit.index === 0)) {
      body.id = rowEdit.data.id;

      if (rowEdit.index !== -1) {
        const copy = [...customerPriceTable];
        copy[rowEdit.index] = body;
        setCustomerPriceTable(copy);
      }
    } else {
      setCustomerPriceTable((current) => [...current, body]);
      notify(
        "Tabela de Preço do Cliente adicionada com sucesso!",
        true,
        "success"
      );
      expanded.customerPriceTable = true;
    }

    setOpen(false);
    setRowEdit(null);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="xl"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Cadastro de Tabela de Preço
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <SelectErp
                error={errorsModal.priceTable ? true : false}
                helperText={errorsModal.priceTable || ""}
                loading={loadingInputs.listPriceTable || false}
                label="Tabela de Preço"
                value={priceTable}
                setValue={setPriceTable}
                optionsList={listPriceTable}
                descriptionField="descricao"
              />
            </Grid>
            <Grid item xs={4}>
              <TextFieldErp
                label="Desconto Padrão da Tabela"
                maxLength={20}
                mask="decimal"
                decimals={2}
                value={defaultDiscount}
                disabled={true}
              />
            </Grid>
            <Grid item xs={4}>
              <TextFieldErp
                error={errorsModal.discount ? true : false}
                helperText={errorsModal.discount || ""}
                label="Desconto"
                maxLength={20}
                mask="decimal"
                decimals={2}
                value={discount}
                setValue={setDiscount}
              />
            </Grid>
            <Grid item xs={4}>
              <TextFieldErp
                error={errorsModal.expirationDate ? true : false}
                helperText={errorsModal.expirationDate || ""}
                label="Data Expiração"
                defaultValue=""
                value={expirationDate}
                setValue={setExpirationDate}
                type="date"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handleAdd} />
        </DialogActions>
      </Dialog>
    </>
  );
}
